<script lang="ts">
    import { apiBaseURL } from "../../config"

    export let event: Event
    export let overview: boolean = false

    const getEventDate = () => {
        const from = event?.from ? new Date(event?.from) : null
        const until = event?.until ? new Date(event?.until) : null
        const options = { year: "numeric", month: "2-digit", day: "2-digit" }
        let d = ""
        if (from) {
            // @ts-ignore
            d += from.toLocaleDateString("de-DE", options)
        }
        if (until) {
            // @ts-ignore
            d += " - " + until.toLocaleDateString("de-DE", options)
        }
        return d
    }
</script>

<div class="event {event?.position}" class:overview>
    <div class="event-header">
        <img src="assets/page/icon-calendar-1.png" alt="Veranstaltung" />
        <span>{getEventDate()}</span>
    </div>
    <div class="event-content">
        {#if event?.position !== "sidebar" || overview}
            {#if event?.event_image?.src}
                <img
                    src="{apiBaseURL +
                        '/events/' +
                        event?.id +
                        '/' +
                        event?.event_image.src +
                        '?filter=l'}"
                    alt="{event?.event_image.path}"
                />
            {/if}
        {/if}
        <div>
            {#if event?.title}
                <div class="event-title mt-sm">{event?.title}</div>
            {/if}
            {#if event?.subtitle}
                <div class="event-subtitle mb-md">
                    {event?.subtitle}
                </div>
            {/if}
            {#if event?.content}
                <div class="mb-md">
                    {@html event?.content}
                </div>
            {/if}
        </div>
    </div>
</div>
